import * as React from 'react';
import { AlertsSectionComponent } from '../../components/Nav/AlertsSection';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { fetchOrganizationIfNeeded } from '@pec/aion-ui-core/actions/organization';
import { fetchTasksCount } from '@pec/aion-ui-core/actions/fetchTasksCount';
import { isAssigneeOrg } from '@pec/aion-ui-core/selectors/organization';
import { Loading } from '../../components/Loading';
import { Location } from 'history';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';

// Take in location so when it changes, the component re-renders and the active
// link styling is refreshed.

type OwnProps = {
  organizationId: string;
  location: Location;
  hasGlobalPermission: (action: ActivityAction, resourceName: ActivityResourceName) => boolean;
  hasOrganizationPermission: (action: ActivityAction, resourceName: ActivityResourceName) => boolean;
};

const mapStateToProps = (state: CommonRootState) => ({ ...state.organization, ...state.notifications });

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organizationId }: OwnProps
) => ({
  fetchOrganizationIfNeeded: () => dispatch(fetchOrganizationIfNeeded(organizationId)),
  fetchTasksCount: (isAssigneeOrg: boolean) => dispatch(fetchTasksCount(organizationId, isAssigneeOrg))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class AlertsSection extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchOrganizationIfNeeded();

    const { organization } = props;

    props.fetchTasksCount(isAssigneeOrg(organization));
  }

  render() {
    const {
      organization,
      isFetching,
      fetchError,
      tasks: tasksCount,
      hasGlobalPermission,
      hasOrganizationPermission
    } = this.props;

    return organization && !isFetching ? (
      <AlertsSectionComponent
        organization={organization}
        notificationCount={tasksCount}
        hasGlobalPermission={hasGlobalPermission}
        hasOrganizationPermission={hasOrganizationPermission}
      />
    ) : fetchError ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const AlertsSectionContainer = connect(mapStateToProps, mapDispatchToProps)(AlertsSection);
